<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-10 10:56:56
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Shift\ShiftType\ShiftType.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-28 11:27:57
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_shiftType_list_title')"
    pad="0"
    :addBtn="hasBtn('add-admin-shift-type')"
    @new="toNew"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :showSelect="showSelect"
        :height="$vuetify.breakpoint.height - 275"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback) => {
            getList(page, perpage, callback);
          }
        "
      >
        <template v-slot:item.name="{ item }">
          <div
            class="text--primary table-title"
            :title="$getCommonLangValue(item.shift_type_name)"
          >
            {{ $getCommonLangValue(item.shift_type_name) }}
          </div>
          <div class="text--secondary table-subtitle">
            {{ $getCommonLangValue(item.shift_type_description) }}
          </div>
        </template>
        <template v-slot:item.abbr="{ item }">
          <div class="text--primary table-title">
            {{ $getCommonLangValue(item.shift_type_abbr) }}
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :delBtn="hasBtn('delete-admin-shift-type')"
            :editBtn="hasBtn('edit-admin-shift-type')"
            :viewBtn="hasBtn('view-admin-shift-type')"
            :uuid="item.uuid"
            :title="$t('label_essweb_shiftType_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
    </template>
    <!-- content -->
    <!-- tools -->
    <template v-slot:tools-main></template>
    <!-- tools -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "ShiftType",
  computed: {},
  mounted() {
    this.getBtnPermissionList();
    this.getList(1, this.$tableSetting.perPageSize, null);
  },
  data() {
    return {
      search: "",
      showSelect: false,
      selected: [],
      totalCount: 0,
      headers: [
        {
          text: "label_essweb_shiftType_list_shiftTypeNameLabel",
          align: "start",
          value: "name",
          sortable: false,
          filter: (value, search, item) => {
            if (!this.search) return true;
            return (
              item.shift_type_name
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1
            );
          },
        },
        {
          text: "label_essweb_shiftType_list_shiftTypeAbbrLabel",
          value: "abbr",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_shiftType_list_shiftActionsLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
    };
  },
  methods: {
    getList: function (page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift_type",
        url: "/shift-type/get-shift-type-list/",
        data: { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback() : null;
      });
    },
    toDelete: function (id) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift_type",
        url: "/shift-type/delete-shift-type-table/",
        data: { uuids: id.toString() },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_shiftType_list_deleteShiftTypeSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== id);
      });
    },
    toNew: function () {
      this.$toPage("/admin/shift-type/add", {});
    },
    toEdit: function (uuid, action) {
      this.$toPage(
        (action == "edit"
          ? "/admin/shift-type/edit/"
          : "/admin/shift-type/detail/") + uuid
      );
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
  },
};
</script>
